var map = {
	"./ActionsModal/Cambio.vue": 771,
	"./ActionsModal/SaveChanges.vue": 772,
	"./ActionsModal/index.vue": 243,
	"./agrocolor.vue": 1977,
	"./araporcei.vue": 1978,
	"./coplaca/ParcelasActionsMultiple.vue": 1090,
	"./coplaca/index.vue": 1979,
	"./default.vue": 1980,
	"./demo.vue": 1981,
	"./sites.vue": 289,
	"./widgets/auditorias.vue": 773,
	"./widgets/dictamenes.vue": 776,
	"./widgets/pacs.vue": 778,
	"./widgets/revisiones.vue": 775,
	"./widgets/solicitudes.vue": 774,
	"./widgets/toma_muestras.vue": 777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1687;